import React, { useState } from 'react'
import { DataTable, Button } from '@paypalcorp/pp-react'

const allRows = [
  {
    id: 'row1',
    testNumber: {
      value: '371449635398431',
    },
    cardType: {
      value: 'American Express',
    },
  },
  {
    id: 'row2',
    testNumber: {
      value: '376680816376961',
    },
    cardType: {
      value: 'American Express',
    },
  },
  {
    id: 'row3',
    testNumber: {
      value: '36461510000039',
    },
    cardType: {
      value: 'Diners Club',
    },
  },
  {
    id: 'row4',
    testNumber: {
      value: '36461510000013',
    },
    cardType: {
      value: 'Diners Club',
    },
  },
  {
    id: 'row5',
    testNumber: {
      value: '6304000000000000',
    },
    cardType: {
      value: 'Maestro',
    },
  },
  {
    id: 'row6',
    testNumber: {
      value: '5063516945005047',
    },
    cardType: {
      value: 'Maestro',
    },
  },
  {
    id: 'row7',
    testNumber: {
      value: '2223000048400011',
    },
    cardType: {
      value: 'Mastercard',
    },
  },
  {
    id: 'row8',
    testNumber: {
      value: '4005519200000004',
    },
    cardType: {
      value: 'Visa',
    },
  },
  {
    id: 'row9',
    testNumber: {
      value: '4012000033330026',
    },
    cardType: {
      value: 'Visa',
    },
  },
  {
    id: 'row10',
    testNumber: {
      value: '4012000077777777',
    },
    cardType: {
      value: 'Visa',
    },
  },
  {
    id: 'row11',
    testNumber: {
      value: '4012888888881881',
    },
    cardType: {
      value: 'Visa',
    },
  },
  {
    id: 'row12',
    testNumber: {
      value: '4217651111111119',
    },
    cardType: {
      value: 'Visa',
    },
  },
  {
    id: 'row13',
    testNumber: {
      value: '4500600000000061',
    },
    cardType: {
      value: 'Visa',
    },
  },
  {
    id: 'row14',
    testNumber: {
      value: '4772129056533503',
    },
    cardType: {
      value: 'Visa',
    },
  },
  {
    id: 'row15',
    testNumber: {
      value: '4915805038587737',
    },
    cardType: {
      value: 'Visa',
    },
  },
  {
    id: 'row16',
    testNumber: {
      value: '6200680000000004',
    },
    cardType: {
      value: 'CUP',
    },
  },
  {
    id: 'row17',
    testNumber: {
      value: '6200680000000038',
    },
    cardType: {
      value: 'CUP',
    },
  },
  {
    id: 'row18',
    testNumber: {
      value: '3636500000000260',
    },
    cardType: {
      value: 'JCB',
    },
  },
  {
    id: 'row19',
    testNumber: {
      value: '3636500000000989',
    },
    cardType: {
      value: 'JCB',
    },
  },
]

const columns = {
  testNumber: {
    title: 'Test number',
    mobile: {
      placement: 'a12',
      width: 'auto',
    },
  },
  cardType: {
    title: 'Card type',
    mobile: {
      placement: 'b3',
    },
  },
}

const TestCardTable = () => {
  const [rows, setRows] = useState(allRows.slice(0, 5))
  const [isLoading, setLoading] = useState(false)
  const showSeeMoreBtn = rows.length < allRows.length

  const handleSeeMore = () => {
    setLoading(true)
    setTimeout(() => {
      setRows((currRowsShown) => allRows.slice(0, currRowsShown.length + 5))
      setLoading(false)
    }, 300)
  }
  return (
    <>
      <DataTable
        description="Basic"
        rows={rows}
        columns={columns}
        isLoading={isLoading}
        idPrefix="basic"
        scroll
        style={{ maxHeight: '36rem', marginTop: '1.5rem' }}
      />
      {showSeeMoreBtn && (
        <div className="table-btnWrapper">
          <Button onClick={handleSeeMore} size="sm" secondary>
            See more
          </Button>
        </div>
      )}
    </>
  )
}

export default TestCardTable
